module.exports = __webpack_public_path__ + "media/icons/cross@2x-91ea17c8.png";